// extracted by mini-css-extract-plugin
export default {"image":"CloudinaryImage___cloudinary-image-module__image___3Qwb2"};